module.exports = __webpack_public_path__ + "img/avatar10.a10f082e.jpg";